<app-splash-screen></app-splash-screen>

<span style="height: 100vh;" [ngClass]="(styling.sharedStyle$ | async)" [ngClass]="(styling.savedFont)">
<router-outlet></router-outlet>
</span>
